<template>
  <div class="about-page content">
    <h1>About TANM</h1>
    <p>
      TANM (Takeaway Near Me) is a new food-ordering platform built for the modern age — faster, more transparent, and more developer-friendly than existing platforms.
    </p>

    <p>
      We’re currently in early development, but the vision is big: provide local takeaways and food businesses with powerful tools to manage menus, accept secure payments via Stripe, and deliver real-time order tracking — just like Domino’s, but available to everyone.
    </p>

    <h2>Why TANM?</h2>
    <ul>
      <li><strong>Speed and Simplicity:</strong> From search to checkout, our focus is on fast, clean UX.</li>
      <li><strong>Live Order Tracking:</strong> Built-in, dynamic progress tracker using SignalR for real-time updates.</li>
      <li><strong>Flexible Vendor Integration:</strong> Future-proof APIs and tools for vendors to plug into their own websites or systems.</li>
      <li><strong>Secure Payments:</strong> Stripe integration with Apple Pay, Google Pay, and card support.</li>
      <li><strong>Authentication:</strong> Google and Microsoft login support with JWT-based auth for future extensibility.</li>
    </ul>

    <h2>Who's Behind It?</h2>
    <p>
      TANM is being built by a hands-on CTO with over 8 years of experience leading development teams and platforms, and a strong background in performance optimization, API integration, and full-stack engineering.
    </p>
    <p>
      With a track record that includes speedrunning world records, running high-performance gaming and tech brands, and building scalable systems from scratch, TANM combines technical muscle with creative vision.
    </p>

    <h2>Early Adopters Welcome</h2>
    <p>
      We're actively building this platform in public. If you're a takeaway owner, developer, or just someone who's hungry for better tech in food delivery — you're in the right place.
    </p>
    <p>
      Follow along, reach out, or explore the roadmap. This is just the beginning.
    </p>

    <router-link to="/sign-up" class="btn">Vendor Signup Coming Soon</router-link>
  </div>
</template>

<style scoped>
  .about-page {
    max-width: 900px;
    margin: 0 auto;
    padding: 40px 20px;
  }

    .about-page h1,
    .about-page h2 {
      margin-top: 40px;
    }

    .about-page p,
    .about-page li {
      line-height: 1.6;
      margin: 15px 0;
    }

    .about-page ul {
      padding-left: 20px;
    }

  .btn {
    display: inline-block;
    padding: 12px 24px;
    margin-top: 30px;
    background: black;
    color: white;
    font-weight: bold;
    border-radius: 5px;
    text-decoration: none;
    transition: background 0.3s ease;
  }

    .btn:hover {
      background: #444;
    }
</style>
